class WebPreferenceSettings {
  constructor() {
    // ボタンとモーダルを取得
    const iconBtns = document.querySelectorAll(
      'button.navlink.web-preference-settings'
    );
    
    // 各ボタンにイベントリスナーを設定
    iconBtns.forEach((btn) => {
      const modalId = btn.getAttribute('data-modal-target');
      const modal = document.getElementById(modalId);
      
      if (modal) {
        // ラジオボタンの変更を監視（言語/配送先のどちらでも「確認」ボタンを活性化）
        this.handleChangeState(modal);
        
        // ボタンクリックイベント
        btn.addEventListener('click', (event) => {
          event.stopPropagation();
          this.handleToggleShowSetting(btn, modal);
        });
        
        // 確認ボタンのイベント
        const confirmBtn = modal.querySelector('.confirm-btn');
        if (confirmBtn) {
          confirmBtn.addEventListener('click', (event) => this.handleConfirmClick(event));
        }
        
        // モーダル内のクリックイベントを設定
        this.setupModalEvents(modal, btn);
      }
    });

    // ページ訪問時に商品可用性を先に判定し、全モーダルへ反映
    this.precomputeMarketAvailability();
  }

  async precomputeMarketAvailability() {
    try {
      const availability = await this._decideMarketAvailability();
      const wrapper = document.querySelector('.header__wrapper');
      if (wrapper) {
        wrapper.dataset.marketJpAvailable = String(!!availability.jp);
        wrapper.dataset.marketIntlAvailable = String(!!availability.intl);
      }
      this._applyAvailabilityToAllModals(availability);
    } catch (_) { /* noop */ }
  }

  handleChangeState(modal) {
    const confirmBtn = modal.querySelector('.confirm-btn');
    const langBtns = modal.querySelectorAll('.language-form input[type="radio"]');
    const countryBtns = modal.querySelectorAll('.country-form input[type="radio"]');

    const activate = () => confirmBtn.classList.add('state-change');
    langBtns.forEach((btn) => btn.addEventListener('change', activate));
    countryBtns.forEach((btn) => btn.addEventListener('change', activate));
  }

  handleToggleShowSetting(button, modal) {
    // 3つエレメントを取得します
    const backgroundEl = modal.querySelector('.floating-modal-background');
    const modalBorderEl = modal.querySelector('.floating-modal-border');
    const internetIconBtn = button.querySelector('.internet-icon');

    const isShowBlackBg = backgroundEl.classList.contains('visible');
    const isShowModal = modalBorderEl.classList.contains('show-setting');
    const isIconActive = internetIconBtn && internetIconBtn.classList.contains('show-setting');

    // 隠さない状態
    if (isShowBlackBg && isShowModal && isIconActive) {
      this.hideModal(backgroundEl, modalBorderEl, internetIconBtn);
    } else if (!isShowBlackBg && !isShowModal && !isIconActive) {
      //隠している状態
      this.showModal(backgroundEl, modalBorderEl, internetIconBtn, button);
    }
  }
  
  setupModalEvents(modal, button) {
    const backgroundEl = modal.querySelector('.floating-modal-background');
    const modalBorderEl = modal.querySelector('.floating-modal-border');
    const internetIconBtn = button.querySelector('.internet-icon');
    
    // 背景クリックで閉じる
    backgroundEl.onclick = (e) => {
      if (e.target === backgroundEl) {
        this.hideModal(backgroundEl, modalBorderEl, internetIconBtn);
      }
    };
    
    // Xボタンクリックで閉じる
    const xIcon = modal.querySelector('.x-icon');
    if (xIcon) {
      xIcon.onclick = () => {
        this.hideModal(backgroundEl, modalBorderEl, internetIconBtn);
      };
    }
  }
  
  showModal(backgroundEl, modalBorderEl, internetIconBtn, buttonElement) {
    // モーダルを表示
    const modal = modalBorderEl.closest('.floating-modal-parent');
    modal.classList.add('modal-visible');

    backgroundEl.classList.add('visible');
    modalBorderEl.classList.add('show-setting');
    if (internetIconBtn) internetIconBtn.classList.add('show-setting');

    // bodyにクラスを追加してスクロールを無効化
    document.body.classList.add('modal-open');

    // 初期表示では「確認」ボタンを非活性状態に戻す
    const confirmBtn = modal.querySelector('.confirm-btn');
    if (confirmBtn) confirmBtn.classList.remove('state-change');

    // 現在の配送国にラジオ表示を同期
    this.syncCountryRadios(modal);
    // 事前判定済みの可用性を用いて、モーダル表示時にも最終確認
    this.ensureAvailableCountryOptions(modal);

    // PC版の場合、ボタンの位置に基づいてモーダルを配置
    if (window.innerWidth >= 769) {
      this.positionModalForPC(buttonElement, modalBorderEl);
    }
  }
  
  positionModalForPC(button, modal) {
    if (!button || !modal) return;
    
    // ボタンが見えているか確認
    const buttonRect = button.getBoundingClientRect();
    if (buttonRect.width === 0 || buttonRect.height === 0) {
      console.warn('Button is not visible, using default position');
      // CSS変数をリセットしてデフォルト位置を使用
      modal.style.removeProperty('--modal-top');
      modal.style.removeProperty('--modal-left');
      modal.style.removeProperty('--modal-right');
      return;
    }
    
    const modalWidth = 240; // PC版のモーダル幅
    const windowWidth = window.innerWidth;
    
    // ボタンの下に配置
    const topPosition = buttonRect.bottom + 24;
    
    // 左右の位置を計算（画面端でのはみ出しを防ぐ）
    let leftPosition = buttonRect.left + (buttonRect.width / 2) - (modalWidth / 2);
    
    // 画面右端からはみ出す場合
    if (leftPosition + modalWidth > windowWidth - 20) {
      leftPosition = windowWidth - modalWidth - 20;
    }
    
    // 画面左端からはみ出す場合
    if (leftPosition < 20) {
      leftPosition = 20;
    }
    
    // CSS変数を使用して位置を設定
    modal.style.setProperty('--modal-top', `${topPosition}px`);
    modal.style.setProperty('--modal-left', `${leftPosition}px`);
    modal.style.setProperty('--modal-right', 'auto');
  }
  
  hideModal(backgroundEl, modalBorderEl, internetIconBtn) {
    // モーダルを非表示
    const modal = modalBorderEl.closest('.floating-modal-parent');
    modal.classList.remove('modal-visible');
    
    backgroundEl.classList.remove('visible');
    modalBorderEl.classList.remove('show-setting');
    if (internetIconBtn) internetIconBtn.classList.remove('show-setting');
    
    // bodyからクラスを削除してスクロールを有効化
    document.body.classList.remove('modal-open');
  }

  // ヘッダーに埋め込んだ現在の国コードに従って、ラジオの見た目を同期
  syncCountryRadios(modal) {
    try {
      const wrapper = document.querySelector('.header__wrapper');
      const iso = (wrapper?.dataset?.countryIso || '').toUpperCase();
      const isJP = iso === 'JP';
      const jp = modal.querySelector('.country-form input[type="radio"][data-country="JP"]');
      const others = modal.querySelector('.country-form input[type="radio"][value="OTHERS"]');
      if (jp && others) {
        if (isJP) { jp.checked = true; others.checked = false; }
        else { others.checked = true; jp.checked = false; }
      }
    } catch (_) { /* noop */ }
  }

  // 事前判定した可用性を全モーダルに適用
  _applyAvailabilityToAllModals(availability) {
    document.querySelectorAll('.country-form').forEach((form) => {
      this._applyAvailabilityToForm(form, availability);
    });
  }

  _applyAvailabilityToForm(form, availability) {
    const jpInput = form.querySelector('input[type="radio"][data-market="jp"]');
    const othInput = form.querySelector('input[type="radio"][data-market="international"]');
    const jpLabel  = jpInput ? form.querySelector(`label[for="${jpInput.id}"]`) : null;
    const othLabel = othInput ? form.querySelector(`label[for="${othInput.id}"]`) : null;

    const markHidden = (input, label) => {
      if (!input) return;
      input.disabled = true;
      input.setAttribute('hidden', '');
      input.setAttribute('aria-hidden', 'true');
      if (label) { label.setAttribute('hidden',''); label.setAttribute('aria-hidden','true'); }
      const prev = input.previousElementSibling;
      if (prev && prev.classList && prev.classList.contains('modal-divider')) prev.setAttribute('hidden','');
    };

    if (availability.jp === false) { markHidden(jpInput, jpLabel); }
    if (availability.intl === false) { markHidden(othInput, othLabel); }
  }

  // 利用可能なマーケット（JP / International）だけを表示する
  async ensureAvailableCountryOptions(modal) {
    // まずは事前判定のデータ属性を利用
    const wrapper = document.querySelector('.header__wrapper');
    const jpAvail = this._parseBoolString(wrapper?.dataset?.marketJpAvailable);
    const intlAvail = this._parseBoolString(wrapper?.dataset?.marketIntlAvailable);
    let availability;
    if (jpAvail !== null && intlAvail !== null) {
      availability = { jp: jpAvail, intl: intlAvail };
    } else {
      availability = await this._decideMarketAvailability();
    }
    const form = modal.querySelector('.country-form');
    if (!form) return;
    const jpInput = form.querySelector('input[type="radio"][data-market="jp"]');
    const othInput = form.querySelector('input[type="radio"][data-market="international"]');
    const jpLabel  = jpInput ? form.querySelector(`label[for="${jpInput.id}"]`) : null;
    const othLabel = othInput ? form.querySelector(`label[for="${othInput.id}"]`) : null;

    const markHidden = (input, label) => {
      if (!input) return;
      input.disabled = true;
      input.setAttribute('hidden', '');
      input.setAttribute('aria-hidden', 'true');
      if (label) { label.setAttribute('hidden',''); label.setAttribute('aria-hidden','true'); }
      const prev = input.previousElementSibling;
      if (prev && prev.classList && prev.classList.contains('modal-divider')) prev.setAttribute('hidden','');
    };

    let changed = false;
    if (availability.jp === false) {
      markHidden(jpInput, jpLabel);
      if (jpInput?.checked && othInput && !othInput.disabled) {
        othInput.checked = true; changed = true;
      }
    }
    if (availability.intl === false) {
      markHidden(othInput, othLabel);
      if (othInput?.checked && jpInput && !jpInput.disabled) {
        jpInput.checked = true; changed = true;
      }
    }
    // 初期表示では活性化しない（ユーザー操作時のみ state-change を付与）
  }

  // JP/International の可用性を判定
  async _decideMarketAvailability() {
    const handle = this._getProductHandle();
    // 初期値: true（不明時は非ブロック）
    let jp = true;
    let intl = true;

    // International は埋め込みフラグを優先
    const presetIntl = this._readIntlFlagFromDOM();
    if (presetIntl === true) intl = true;
    if (presetIntl === false) intl = false;

    // ネットワークで確認（商品ページのみ）
    if (handle) {
      const controller = new AbortController();
      const to = setTimeout(() => controller.abort(), 2500);
      try {
        // JP 可用性
        const resJP = await fetch(`/products/${encodeURIComponent(handle)}.js?country=JP`, { method: 'GET', cache: 'no-store', credentials: 'omit', signal: controller.signal });
        if (resJP.status === 404) jp = false;
        // International 可用性（未確定なら確認）
        if (presetIntl === null) {
          const resUS = await fetch(`/products/${encodeURIComponent(handle)}.js?country=US`, { method: 'GET', cache: 'no-store', credentials: 'omit', signal: controller.signal });
          if (resUS.status === 404) intl = false;
        }
      } catch (_) {
        // タイムアウトやCORS時は既定値のまま
      } finally { clearTimeout(to); }
    }

    return { jp, intl };
  }

  _parseBoolString(v) {
    const s = (v || '').toString().toLowerCase();
    if (s === 'true') return true;
    if (s === 'false') return false;
    return null;
  }

  // --- Others（国際マーケット）公開可否の事前判定 ---
  _readIntlFlagFromDOM() {
    const wrapper = document.querySelector('.header__wrapper');
    if (!wrapper) return null;
    // 事前計算された可用性があれば優先
    const fromMarket = this._parseBoolString(wrapper.dataset.marketIntlAvailable);
    if (fromMarket !== null) return fromMarket;
    const v = (wrapper.dataset.intlAvailable || '').toLowerCase();
    if (v === 'true') return true;
    if (v === 'false') return false;
    return null;
  }

  _getProductHandle() {
    const wrapper = document.querySelector('.header__wrapper');
    if (wrapper?.dataset?.productHandle) return wrapper.dataset.productHandle;
    const handle = (window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product && window.ShopifyAnalytics.meta.product.handle) || null;
    return handle || null;
  }

  _showInlineNotice(modal, msg) {
    if (!modal) return;
    let note = modal.querySelector('.wpref-note');
    if (!note) {
      note = document.createElement('p');
      note.className = 'wpref-note';
      note.style.cssText = 'margin-top:8px;font-size:12px;color:#b91c1c;';
      modal.querySelector('.floating-modal')?.appendChild(note);
    }
    note.textContent = msg;
  }

  async _decideOthersVisibility() {
    const preset = this._readIntlFlagFromDOM();
    if (preset === true) return true;
    if (preset === false) return false;

    const handle = this._getProductHandle();
    if (!handle) return true; // 商品以外のページはブロックしない

    const countryCode = 'US';
    const tryUrls = [
      `/products/${encodeURIComponent(handle)}.js?country=${encodeURIComponent(countryCode)}`,
      `/en/products/${encodeURIComponent(handle)}.js`,
    ];

    const controller = new AbortController();
    const to = setTimeout(() => controller.abort(), 2500);

    let available = null;
    for (const u of tryUrls) {
      try {
        const res = await fetch(u, { method: 'GET', cache: 'no-store', credentials: 'omit', signal: controller.signal });
        if (res.status === 404) { available = false; break; }
        if (res.ok && res.headers.get('content-type')?.includes('application/json')) {
          const js = await res.json().catch(() => null);
          if (js && js.id) { available = true; break; }
        }
      } catch (_) { /* ignore */ }
    }
    clearTimeout(to);
    return available !== false;
  }

  async handleConfirmClick(event) {
    const confirmBtn = event.target.closest('.confirm-btn');
    if (!confirmBtn) return;
    event.preventDefault();
    event.stopPropagation();

    const modal = event.target.closest('.floating-modal-parent');
    if (!modal) return;
    await this.applyLocalizationFromModal(modal);
  }

  async applyLocalizationFromModal(modal) {

    const langEl = modal.querySelector('.language-form input[type="radio"]:checked');
    const countryEl = modal.querySelector('.country-form input[type="radio"]:checked');

    const localeCode = langEl?.value === 'EN' ? 'en' : 'ja';
    const isOthers = countryEl?.value === 'OTHERS';

    if (isOthers) {
      const ok = await this._decideOthersVisibility();
      if (!ok) {
        this._showInlineNotice(modal, 'この商品は国際マーケットでは公開されていないため、配送国を「Others」には変更できません。');
        // JP に戻す
        const jp = modal.querySelector('.country-form input[data-market="jp"]');
        if (jp) {
          jp.checked = true;
          jp.dispatchEvent(new Event('change', { bubbles: true }));
        }
        return;
      }
    }

    const countryCode = countryEl?.dataset.country || 'JP';

    // 戻り先 URL を現在の言語指定に合わせて計算
    const url = new URL(window.location.href);
    const hasEn = url.pathname.startsWith('/en');
    if (localeCode === 'en' && !hasEn) url.pathname = `/en${url.pathname}`;
    if (localeCode === 'ja' && hasEn) url.pathname = url.pathname.replace(/^\/en/, '') || '/';
    const returnTo = url.pathname + url.search + url.hash;

    try {
      const fd = new FormData();
      fd.set('form_type', 'localization');
      fd.set('utf8', '✓');
      fd.set('locale_code', localeCode);
      fd.set('country_code', countryCode);
      fd.set('return_to', returnTo);

      const res = await fetch('/localization', { method: 'POST', body: fd, credentials: 'same-origin' });
      if (!res.ok) throw new Error('Localization POST failed: ' + res.status);
      window.location.replace(returnTo);
    } catch (e) {
      console.error(e);
      const form = document.getElementById('localization-form-drawer') || document.querySelector('form[action$="/localization"]');
      if (form) {
        const ensure = (name, value) => {
          let input = form.querySelector(`input[name="${name}"]`);
          if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = name; form.appendChild(input); }
          input.value = value;
        };
        ensure('locale_code', localeCode);
        ensure('country_code', countryCode);
        ensure('return_to', returnTo);
        ensure('form_type', 'localization');
        ensure('utf8', '✓');
        form.submit();
      }
    } finally {
      // モーダルクローズ
      const backgroundEl = modal.querySelector('.floating-modal-background');
      const modalBorderEl = modal.querySelector('.floating-modal-border');
      const relatedButtonId = modal.id === 'language-modal-left' ? 'language-modal-left' : 'language-modal-right';
      const button = document.querySelector(`button.web-preference-settings[data-modal-target="${relatedButtonId}"]`);
      const internetIconBtn = button?.querySelector('.internet-icon');
      this.hideModal(backgroundEl, modalBorderEl, internetIconBtn || null);
    }
  }
}

new WebPreferenceSettings();
